import { render } from "./rewards.vue?vue&type=template&id=ad45e588"
import script from "./rewards.vue?vue&type=script&lang=js"
export * from "./rewards.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__